import { useSelector } from 'react-redux';
import { getAssociatedVdpEventId } from '~/selectors';

export default function useAnchorAttributes(vehicleId: number) {
  const associatedVdpEventId = useSelector(getAssociatedVdpEventId);

  return {
    'data-native-link': 'self' as const,
    'data-native-payload': JSON.stringify({ associatedVdpEventId, vehicleId }),
    href: `/vehicle/${vehicleId}`
  };
}
